import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function ProtectedRoute() {
  const { state } = useAuth();

  switch (state.status) {
    case 'loading':
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-brand-rose border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-slate-500 font-medium">Loading...</p>
          </div>
        </div>
      );

    case 'unauthenticated':
      return <Navigate to="/login" replace />;

    case 'totp_setup':
      return <Navigate to="/totp-setup" replace />;

    case 'totp_verify':
      return <Navigate to="/2fa" replace />;

    case 'password_expired':
      return <Navigate to="/force-change-password" replace />;

    case 'authenticated':
      return <Outlet />;
  }
}
